import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "introduce-archer",
    "stage": {
        "image": require("./image.png"),
        "imageOffset": {"x": -6, "y": -1},
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "width": 18,
            "height": 10,
        }),
        "conditions": convertOldChapterScripting({
            "0:start": [
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "oriana", "side": "right",
                        "text": "More foes.",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "oriana", "side": "right",
                        "text": "3 vs 1? I don't like these numbers.",
                        "expression": "angry"
                    }
                },
                {
                    "type": "StopDialogue"
                }
            ],
            "2:start": [
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "text": "Oho, I'm late!",
                        "face": undefined,
                        "name": "???",
                    }
                },
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "brigid",
                        "position": {"x": -1, "y": 6},
                        "affiliation": "good",
                        "maxhealth": 30
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 0, "y": 6},
                    "classKey": "brigid",
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 0, "y": 5},
                    "classKey": "brigid",
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "text": "My bow is yours!",
                        "face": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/phil.face.png"),
                        "name": "brigid",
                        "exression": "happy",
                    }
                },
                {
                    "type": "StopDialogue",
                },
            ],
            "1:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#1",
                        "position": {"x": 3, "y": 8},
                        "classKey": "berserker",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 3, "y": 7},
                    "classKey": "#1",
                },
                // {
                //     "type": "DisplayDialogue",
                //     "dialogue": {
                //         "text": "More baddies to the south!",
                //         "face": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/phil.face.png"),
                //         "name": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/phil.name.png"),
                //     }
                // },
            ],
            "3:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#9",
                        "position": {"x": 4, "y": -1},
                        "classKey": "archer",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 4, "y": 0},
                    "classKey": "#9",
                },
            ]
        }, [
            {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
            {"type": "FinishLocation", "locationKey": "2"},
            {"type": "UnlockLocations", "routeKeys": ["4", "5"], "locationKeys": ["3"]},
            {"type": "UnlockLocations", "routeKeys": ["A1", "A2"], "locationKeys": ["A"]},
        ], {
            "turns": 4,
            "condition": "KILL"
        })
    },
}

// // https://serenesforest.net/wp-content/uploads/2017/02/63.png
// "introduce-archer": {
//     "hasPreparation": false,
//     "music": "hero",
//     "victory": {
//         "turns": 4,
//         "condition": "KILL"
//     },
//     "events": {
//         "0:start": [
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana", "side": "right",
//                     "text": "More foes.",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana", "side": "right",
//                     "text": "3 vs 1? I don't like these numbers.",
//                 }
//             },
//             {
//                 "type": "StopDialogue"
//             }
//         ],
//         "2:start": [
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "text": "Oho, I'm late!",
//                     "face": undefined,
//                     "name": "???",
//                 }
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "brigid",
//                     "position": {"x": -1, "y": 6},
//                     "affiliation": "good",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 0, "y": 6},
//                 "classKey": "brigid",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 0, "y": 5},
//                 "classKey": "brigid",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "text": "My bow is yours!",
//                     "face": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/phil.face.png"),
//                     "name": "brigid",
//                 }
//             },
//             {
//                 "type": "StopDialogue",
//             },
//         ],
//         "3:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 3, "y": 8},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 3, "y": 7},
//                 "classKey": "#1",
//             },
//             // {
//             //     "type": "DisplayDialogue",
//             //     "dialogue": {
//             //         "text": "More baddies to the south!",
//             //         "face": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/phil.face.png"),
//             //         "name": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/phil.name.png"),
//             //     }
//             // },
//         ]
//     },
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/bridges.png"),
//         "tiles": [
//             {"position": {"x": 1, "y": 4}, "passable": false},
//             {"position": {"x": 1, "y": 6}, "passable": false},
//             {"position": {"x": 1, "y": 7}, "passable": false},
//             {"position": {"x": 0, "y": 7}, "passable": false},
//             {"position": {"x": 3, "y": 2}, "passable": false},
//             {"position": {"x": 3, "y": 3}, "passable": false},
//             {"position": {"x": 3, "y": 4}, "passable": false},
//             {"position": {"x": 5, "y": 2}, "passable": false},
//             {"position": {"x": 5, "y": 3}, "passable": false},
//             {"position": {"x": 5, "y": 4}, "passable": false},
//             {"position": {"x": 1, "y": 1}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_3.png")},
//             {"position": {"x": 5, "y": 0}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_2.png")},
//             {"position": {"x": 5, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 3, "y": 6}, "affiliation": "good"},
//         // {"position": {x: 3, y: 7}, "affiliation": "good"},
//         // {"position": {x: 4, y: 7}, "affiliation": "good"},
//         {"position": {"x": 2, "y": 3}, "affiliation": "bad", "classKey": "berserker"},
//         {"position": {"x": 0, "y": 2}, "affiliation": "bad", "classKey": "rogue"},
//         {"position": {"x": 3, "y": 1}, "affiliation": "bad", "classKey": "archer"},
//     ],
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
//         {"type": "FinishLocation", "locationKey": "2"},
//         {"type": "UnlockLocations", "routeKeys": ["4", "5"], "locationKeys": ["3"]},
//         {"type": "UnlockLocations", "routeKeys": ["A1", "A2"], "locationKeys": ["A"]},
//     ],
//     "nextUrl": "/games/hero/chapters/upgrade-mercenary",
// },
